import { render } from "./SavingsEditor.vue?vue&type=template&id=394e9df2&ts=true"
import script from "./SavingsEditor.vue?vue&type=script&lang=ts"
export * from "./SavingsEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__